import { Record, List } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { CountryList } from 'enums/country';
import TeamModel from './TeamModel';

const EntityRecord = Record({
  id: 0,
  entityId: 0,
  companyNumber: '',
  registrationNumber: '',
  companyName: '',
  entityType: 0,
  introducerType: 0,
  companyType: 0,
  contactName: '',
  contactEmail: '',
  countryCode: CountryList.GB,
  logo: '',
  lenderType: 0,
  description: '',
  teams: List(),
  userLastInvitedAt: 0,
  integratedFrom: '',
  integratedCompanyName: '',
});

export default class Entity extends EntityRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const mapProperties = {
      teams: Hydrator.fromList(TeamModel.deserialize),
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new Entity(hydrated);
  }

  static fromSearch(jsonObject = {}) {
    const keyTransformer = {
      name: 'companyName',
      code: 'companyNumber',
    };

    const hydrated = Object.keys(jsonObject).reduce(
      Hydrator.assign(jsonObject, {}, keyTransformer),
      {},
    );

    return new Entity(hydrated);
  }

  normalize() {
    return this.merge({
      teams: this.get('teams', List()).map((team) => team.id),
    });
  }

  denormalize({ teams, members }) {
    return this.merge({
      teams: this.teams.map((teamId) => teams.get(teamId).denormalize({ members })),
    });
  }
}
